import { NOTIFICATION_TYPES, type NotificationType } from '../../constants';

/**
 * Notification types shown under the Pickups chip.
 * Add new pickup-family types here when they get a card in that chip.
 */
export const PICKUP_CHIP_NOTIFICATION_TYPES = [
  NOTIFICATION_TYPES.TO_BE_REVIEWED_PICKUP,
] as const;

export type PickupChipNotificationType = (typeof PICKUP_CHIP_NOTIFICATION_TYPES)[number];

export const isPickupChipNotification = (
  item: { type?: string } | null | undefined
): boolean =>
  Boolean(
    item?.type &&
      (PICKUP_CHIP_NOTIFICATION_TYPES as readonly NotificationType[]).includes(
        item.type as NotificationType
      )
  );
